import { Box, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import classes from "./OutSourcingMailSetting.module.scss";
import SettingOutsourcingToMail from "../../setting/outSourcingMailSetting/SettingOutsourcingToMail";
import SettingOutsourcingCcMail from "../../setting/outSourcingMailSetting/SettingOutsourcingCcMail";
const OutSourcingMailSetting = () => {
  const theme = useTheme();
  const isIphone = useMediaQuery(theme.breakpoints.down("sm"));
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        flexGrow: 1,
        width: "100%",
        padding: "10px",
        gap: "30px",
        maxHeight: "calc(100vh - 60px)",
        overflow: "auto",
      }}
    >
      <SettingOutsourcingToMail />
      <SettingOutsourcingCcMail />
      <div></div>
    </Box>
  );
};

export default OutSourcingMailSetting;
